import { RouterProvider } from "react-router-dom";
import "@src/app/localization/i18n";
import { QueryClient, QueryClientProvider } from "react-query";
import { router } from "@src/router";
import AxiosProvider from "@src/utils/axios/AxiosProvider";

const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AxiosProvider>
        <RouterProvider router={router} />
      </AxiosProvider>
    </QueryClientProvider>
  );
}

export default App;
